(function (angular) {
    angular.module('app.purchase', [
        'ui.keypress',
        'vcRecaptcha'
    ]);

}(angular));